import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactTooltip } from 'tooltip'
import { base } from './bot-loaders'
import { useConfirm } from './components/Dialogs'

export function SiteHeader(){
    const navigate = useNavigate()
    const confirm = useConfirm(<LeaveQuestion />, {ok: "Sair"});

    async function logout(){
        if(await confirm())
            window.location.href = `${base}logout`
    }

    return <div className='site-header d-flex align-items-center justify-content-between mb-3'>
        <ReactTooltip placement='bottom' delay={300} tooltip="Clique para voltar ao início">
            <img className='resgata-logo' style={{cursor:'pointer'}} src={`${base}logo-resgata-facil.png`} width={67 * 3.76} height={67} onClick={() => navigate('/')} />
        </ReactTooltip>
        <a onClick={logout} className='btn btn-primary'><i className='fa fa-arrow-right-to-bracket'></i></a>    
    </div>
}

function LeaveQuestion(){
    return <div className='d-flex align-items-center'>
        <i className='fa fa-exclamation-triangle fa-2x me-2'></i> 
        <span className='flex-grow-1'>Deseja encerrar a sessão?</span>
    </div>
}